import React from "react";
import DatePicker from "react-datepicker";
import { InputGroup, InputGroupAddon, InputGroupText } from "reactstrap";
const ReactDatePicker = ({
  className = "col-md-3  col-lg-3 col-xl-2",
  wrapperClassName = "datePicker",
  id = "",
  name = "",
  selected = "",
  placeholderText = "dd-mm-yyyy",
  dateFormat = "dd-MM-yyyy",
  starick, // it use for * sign for validation
  autoComplete = "",
  isSelected = "",
  value = "",
  label = "",
  maxDate = "",
  minDate = "",
  onChange = () => { },
  onCalendarClose = () => { },
  isRequired = true,
  isDisabled = false,
  customClass = false,
  // Month-only mode (Monthly Consumption). Passed through explicitly rather than
  // spreading ...rest into DatePicker - several screens already pass props this
  // wrapper silently drops, and forwarding them all would change their behaviour.
  showMonthYearPicker = false,
  ...rest
}) => {
  return (
    <div className={className}>
      {label && (
        <label Htmlfor="exampleFormControlInput1">{label}</label>
      )

      }
      {starick && <span className="text-danger">*</span>}
      <div className="d-flex flex-row">
        <DatePicker
          className="form-control"
          wrapperClassName="datePicker"
          id={id}
          selected={isSelected}
          required={isRequired}
          disabled={isDisabled}
          minDate={minDate}
          maxDate={maxDate}
          placeholderText={placeholderText}
          dateFormat={dateFormat}
          showMonthYearPicker={showMonthYearPicker}
          autoComplete={autoComplete}
          //   value={value}
          onChange={onChange}
          onCalendarClose={onCalendarClose}
        />
        <InputGroupAddon addonType="prepend">
          <InputGroupText className="calended_icon mb-0">
            <i class="fa fa-calendar-plus-o" aria-hidden="true" />
          </InputGroupText>
        </InputGroupAddon>
      </div>
    </div>
  );
};

export default ReactDatePicker;
